// extracted by mini-css-extract-plugin
module.exports = {"confirm_btn":"GlobalOkCancelBtn_confirm_btn__22hsS"};